import config from "../config";

const apiUrl = config.apiUrl;

export const getServices = async () => {
  const response = await fetch(`${apiUrl}/services`);
  const data = await response.json();
  return data;
};
